import { compact, includes, map } from 'lodash'
import { useContext } from 'react'
import { UserRole } from '../api/models'
import { AppStateContext } from '../state/AppProvider'

export const hasPermission = (requiredPermission: string): boolean => {
  const appContext = useContext(AppStateContext)

  return includes(appContext?.state.permissions, requiredPermission)
}

export const extractTruePermissions = (permissions: Record<string, boolean>): string[] => {
  return compact(map(permissions, (value, key) => (value === true ? key : null)))
}

export const getRoleLabel = (role: string) => {
  switch (role) {
    case UserRole.ADMIN:
      return 'Admin'
    case UserRole.DECODER:
      return 'Decoder'
    case UserRole.OU_ORCHESTRATOR:
      return 'OU Orchestrator'
    case UserRole.EDITOR:
      return 'Editor'
    case UserRole.VIEWER:
      return 'Viewer'
  }
}
